import { React, useState, useEffect, Fragment, useRef } from 'react';
import { useParams } from 'react-router-dom';
import {
  Spinner,
  Alert,
  BlockchainService,
  ProjectService,
  ConfigService,
} from '../../services';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useWalletProvider from '../../components/hooks/useWalletProvider';
import moment from 'moment';
import 'react-tooltip/dist/react-tooltip.css';
import OnchainActivities from '../../components/OnchainActivities';
import { Dialog, Transition } from '@headlessui/react';
import ConfirmationPop from '../../components/ConfirmationPop';
import 'react-loading-skeleton/dist/skeleton.css';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import MDEditor from '@uiw/react-md-editor';
import {
  CrossIcon,
  EditIcon,
  GoToLinkIcon,
  InfoCheckIcon,
  LeftArrowIcon,
  ProcessingIcon,
  RightClickIcon,
} from '../../components/icons/IconProvider';
import { formatValue } from '../../utils/Helper';
import NoDataFound from '../../components/NoDataFound';
import TableComponent from '../../components/TableComponent';

const ProjectDetails = () => {
  const [isMintPop, setMintPop] = useState(false);
  const [isLoader, setLoader] = useState(true);
  const [isMintingProcessPop, setMintingProcessPop] = useState(false);
  const [isMintingConfirmationPop, setMintingConfirmationPop] = useState(false);
  const [isMintedSucessPop, setMintedSucessPop] = useState(false);
  const [isDeploySuccessPop, setDeploySuccessPop] = useState(false);
  const [isCommonConfirmationPop, setCommonConfirmationPop] = useState(false);
  const cancelButtonRef = useRef(null);
  const [isMintingListUpdate, setMintingListUpdate] = useState(false);
  const [isNavigateToEdit, setIsNavigateToEdit] = useState(false);

  const { connectWallet } = useWalletProvider();
  const { wallet } = useSelector((state) => state.wallet);
  let params = useParams();
  const navigate = useNavigate();
  let projectId = params ? params.id : null;
  const [projectDetails, setProjectDetails] = useState([]);
  const [, setUserInvestment] = useState([]);
  const [investorsList, setInvestorslist] = useState([]);
  const [isDeployButtonStatus, setDeployButtonStatus] = useState(false);
  const [isNftTotalSupply, setNftTotalSupply] = useState(0);
  const [isNftMintQty, setNftMintQty] = useState(0);
  const [isDetailsLoader, setDetailsLoader] = useState(true);
  const [isNftMintErrorMsg, setNftMintErrorMsg] = useState(null);
  const [isFreeze, setFreezeStatus] = useState(null);
  const [isBlockChainProcessMsg, setBlockChainProcessMsg] = useState(null);
  const [isConfirmationPopData, setConfirmationPopData] = useState({
    FirstText: '',
    SecondText: '',
    FirstButton: '',
    secondButton: '',
    slug: '',
  });
  const [, setEnabled] = useState(false);
  const [showDeployLoader, setShowDeployLoader] = useState(false);
  useEffect(() => {
    (async () => {
      await getProjectDetails(projectId, true);
    })();
  }, []);

  const getProjectDetails = async (projectId, loader = false) => {
    if (loader) {
      setDetailsLoader(true);
    }

    try {
      let response = await ProjectService.getProjectDetails(projectId);

      if (response.status === 'failure') {
        setDetailsLoader(false);
        Alert.error(response.message);
        if (response.message === 'Project does not exists.') {
          navigate('/assets');
          return false;
        }
      }

      response.data.projectImages.splice(0, 0, {
        resourceUrl: response.data.project_image
          ? response.data.project_image
          : null,
      });
      setFreezeStatus(response?.data.transfer_freezed || false);
      setProjectDetails(response?.data);
      setUserInvestment(response?.data?.userInvestment);
      setInvestorslist(response?.data?.userInvestment);
      setDetailsLoader(false);
      setLoader(false);

      setNftTotalSupply(response?.data?.actual_total_supply);

      setEnabled(response.data.is_active === 1 ? true : false);
    } catch (error) {
      setDetailsLoader(false);
      Alert.error(error.message);
      return false;
    }
  };
  const publishProject = async (status, minted, _type = true) => {
    if (minted - isNftTotalSupply !== 0) {
      setMintingConfirmationPop(true);
      return false;
    }

    if (_type) {
      if (status === 1) {
        setConfirmationPopData({
          FirstText: 'Unpublish Project',
          SecondText: 'Are you sure, Would you like to unpublish this project?',
          FirstButton: 'Cancel',
          secondButton: 'Unpublish',
          slug: 'unpublish',
        });
      } else {
        setConfirmationPopData({
          FirstText: 'Publish Project',
          SecondText: 'Are you sure, Would you like to publish this project?',
          FirstButton: 'Cancel',
          secondButton: 'Publish Now',
          slug: 'publish',
        });
      }

      setCommonConfirmationPop(true);
      return false;
    }

    Spinner.show();
    try {
      const formData = {
        project_id: Number(projectId),
        project_status: status === 1 ? 0 : 1,
      };
      let response = await ProjectService.publishProject(formData);

      if (response.status === 'failure') {
        Spinner.hide();
        Alert.error(response.message);
        return false;
      }

      await getProjectDetails(Number(projectId));
      Alert.success(response.message);
      Spinner.hide();

      // check if edit is set
      setIsNavigateToEdit(false);
      isNavigateToEdit && navigate('/assets/addedit/' + projectId);
    } catch (error) {
      Spinner.hide();
      Alert.error(error.message);
      return false;
    }
  };

  const deployProject = async (_type = true) => {
    if (_type) {
      setConfirmationPopData({
        FirstText: 'Deploy Project',
        SecondText: 'Are you sure, Do you want to deploy this project?',
        FirstButton: "I'll do it later",
        secondButton: 'Deploy',
        slug: 'deploy',
      });
      setCommonConfirmationPop(true);
      return false;
    }
    setShowDeployLoader(true);

    try {
      let formData = {
        project_id: projectDetails.id,
      };

      let response = await ProjectService.deploy(formData);

      if (response.status === 'failure') {
        setShowDeployLoader(false);
        Alert.error(response.message);
        return false;
      }

      handleClickScroll();
      setDeploySuccessPop(true);

      setMintingListUpdate(true);
      setShowDeployLoader(false);
    } catch (error) {
      setShowDeployLoader(false);
      Alert.error(error.message);
    }
  };

  const freezeTransfer = async (_type = true) => {
    try {
      if (wallet === null) {
        Alert.error('Please connect to the wallet');
        return false;
      }
      if (_type) {
        setConfirmationPopData({
          FirstText: 'Are you sure?',
          SecondText:
            'Once you freeze the transfer, all the transfer activities of this project will be halted.',
          FirstButton: 'No',
          secondButton: 'Yes',
          slug: 'transferFreeze',
        });
        setCommonConfirmationPop(true);
        return false;
      }

      setBlockChainProcessMsg('Project freeze has been initiated');
      setMintingProcessPop(true);
      let response = await BlockchainService.handleNftFreeze(
        projectDetails.investment_type,
        projectDetails.contract_address,
        true,
      );

      if (response.status === 'failure') {
        setMintingProcessPop(false);
        Alert.error(response.message);
        return false;
      }
      let formData = {
        project_id: projectId,
        type: 'freeze',
        txn_hash: response.data.hash,
      };
      let res = await ProjectService.projectFreezeUnfreeze(formData);

      if (res.status === 'failure') {
        setMintingProcessPop(false);
        Alert.error(res.message);
      }
      setMintingProcessPop(false);
      setFreezeStatus(true);
      setMintingListUpdate(true);
      Alert.success(response.message);
    } catch (error) {
      Alert.error(error.message);
      setMintingProcessPop(false);
      return false;
    }
  };

  const unFreezeTransfer = async (_type = true) => {
    try {
      if (wallet === null) {
        Alert.error('Please connect to the wallet');
        return false;
      }
      if (_type) {
        setConfirmationPopData({
          FirstText: 'Are you sure?',
          SecondText:
            'Once you unfreeze the transfer, all the transfer activities of this project will be enabled',
          FirstButton: 'No',
          secondButton: 'Yes',
          slug: 'transferFreeze',
        });
        setCommonConfirmationPop(true);
        return false;
      }

      setBlockChainProcessMsg('Project un freeze has been initiated');
      setMintingProcessPop(true);
      let response = await BlockchainService.handleNftFreeze(
        projectDetails.investment_type,
        projectDetails.contract_address,
        false,
      );

      if (response.status === 'failure') {
        setMintingProcessPop(false);
        Alert.error(response.message);
        return false;
      }
      let formData = {
        project_id: projectId,
        type: 'unfreeze',
        txn_hash: response.data.hash,
      };
      let res = await ProjectService.projectFreezeUnfreeze(formData);

      if (res.status === 'failure') {
        setMintingProcessPop(false);
        Alert.error(res.message);
      }
      setMintingListUpdate(true);
      setMintingProcessPop(false);
      setFreezeStatus(false);
    } catch (error) {
      Alert.error(error.message);
      setMintingProcessPop(false);
      return false;
    }
  };

  const nftMintingTotalSupply = async () => {
    try {
      let formDataNew = {
        project_id: projectId,
      };
      let resSupply = await ProjectService.checkProjectSupply(formDataNew);

      if (resSupply.status === 'failure') {
        Alert.error(resSupply.message);
        return false;
      }
      setNftTotalSupply(resSupply.data.totalMintQty);
      setMintingListUpdate(true);
    } catch (error) {
      Alert.error(error.message);
      return false;
    }
  };

  const confirmationPopHandel = async (slug) => {
    if (slug === 'transferFreeze') {
      if (isFreeze) {
        setCommonConfirmationPop(false);
        await unFreezeTransfer(false);
        return false;
      } else {
        setCommonConfirmationPop(false);
        await freezeTransfer(false);
        return false;
      }
    }

    if (slug === 'deploy') {
      setCommonConfirmationPop(false);
      await deployProject(false);
      return false;
    }
    if (slug === 'publish' || slug === 'unpublish') {
      setCommonConfirmationPop(false);
      await publishProject(
        projectDetails?.project_status,
        projectDetails.total_minted,
        false,
      );
      return false;
    }
    if (slug === 'redirect') {
      setCommonConfirmationPop(false);
      return false;
    }
  };

  const checkError = async (e) => {
    setNftMintQty(e.target.value);
    setNftMintErrorMsg(null);
    let Value = e.target.value;
    if (Value.includes('e')) {
      setNftMintErrorMsg('Please enter a valid number.');
      return false;
    }
    var ans = Value.toString().includes('.') ? true : false;
    if (ans) {
      setNftMintErrorMsg('Invalid token count. Please enter correct value.');
      return false;
    }
    if (Value <= 0) {
      setNftMintErrorMsg('Please enter a quantity greater than the 0.');
      return false;
    }
    if (Value > projectDetails?.total_minted - isNftTotalSupply) {
      setNftMintErrorMsg(
        'Quantity cannot be greater than the available quanity for mint',
      );
      return false;
    }
  };
  const nftMintRequest = async () => {
    try {
      if (wallet === null) {
        await connectWallet();
        return false;
      }
      if (isNftMintQty <= 0) {
        Alert.error('Please enter a quantity greater than the 0.');
        return false;
      }
      let formDataNew = {
        project_id: projectId,
      };
      setBlockChainProcessMsg('Token minting has been initiated');
      setMintingProcessPop(true);
      let resSupply = await ProjectService.checkProjectSupply(formDataNew);

      if (resSupply.status === 'failure') {
        setMintingProcessPop(false);
        Alert.error(resSupply.message);
        return false;
      }

      if (
        parseInt(resSupply.data.totalMintQty) >= projectDetails?.total_minted
      ) {
        setMintingProcessPop(false);
        Alert.error(
          'You cannot mint more than the provided total supply of' +
            projectDetails?.total_minted,
        );
        return false;
      }

      let response = await BlockchainService.mintToken(
        projectDetails.investment_type,
        projectDetails.contract_address,
        isNftMintQty,
      );
      if (response.status === 'failure') {
        setMintingProcessPop(false);
        Alert.error(response.message);
        return false;
      }

      let formData = {
        project_id: projectId,
        quantity: isNftMintQty,
        txn_hash: response.data.hash,
      };
      let res = await ProjectService.mintTokens(formData);

      if (res.status === 'failure') {
        setMintingProcessPop(false);
        Alert.error(res.message);
      }
      nftMintingTotalSupply();
      setMintingProcessPop(false);
      setMintPop(false);
      setMintingListUpdate(true);
      setMintedSucessPop(true);
    } catch (error) {
      Alert.error(error.message);
      setMintingProcessPop(false);
      return false;
    }
  };
  const editProjectRedirect = (_projectId) => {
    navigate('/assets/addedit/' + _projectId);
  };

  const handleClickScroll = () => {
    const element = document.getElementById('onChain-list');
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const getMaxMintable = () => {
    let maxMintable = projectDetails?.total_minted - isNftTotalSupply;

    if (
      projectDetails.investment_type === 'asset' &&
      projectDetails?.total_minted - isNftTotalSupply > 5000
    ) {
      maxMintable = 5000;
    }
    setNftMintQty(maxMintable);
    setNftMintErrorMsg(null);
  };

  const userRedirect = (userId) => {
    navigate('/users/view/' + userId);
  };

  return (
    <div>
      <div className="flex items-center mb-3">
        <button
          onClick={() => navigate(-1)}
          className="w-11 h-11 flex items-center justify-center mr-3 text-brandBlue p-0"
        >
          <LeftArrowIcon />
        </button>
        <h4 className="">Project Details</h4>
      </div>
      <div className="lg:grid lg:grid-cols-2 lg:gap-8">
        <ProjectInfo
          isDetailsLoader={isDetailsLoader}
          projectDetails={projectDetails}
          showDeployLoader={showDeployLoader}
          isDeployButtonStatus={isDeployButtonStatus}
          editProjectRedirect={editProjectRedirect}
          deployProject={deployProject}
          setIsNavigateToEdit={setIsNavigateToEdit}
          publishProject={publishProject}
        />

        {/* {projectDetails.contract_address !== null && ( */}
        <div className="col-span-2 mt-5" id="onChain-list">
          <div className="bg-brandGray p-5 rounded-lg w-full ">
            <div className="grid md:grid-cols-2 gap-4 mb-4">
              <div>
                <h3 className="">Onchain Activities</h3>
                <p></p>
              </div>
              <div className="md:text-right flex items-center md:justify-end justify-between">
                <p className="text-base mr-3">
                  Token to be minted:{' '}
                  <span className="font-semibold">
                    {projectDetails?.total_minted - isNftTotalSupply || 0}
                  </span>{' '}
                  <span className="opacity-70 ">
                    / {projectDetails?.total_minted || 0}
                  </span>
                </p>
                <div className="flex gap-3">
                  <button
                    className={
                      projectDetails?.total_minted - isNftTotalSupply === 0 ||
                      projectDetails.contract_address === null ||
                      isDetailsLoader === true
                        ? 'font-semibold text-white text-sm bg-[#787a7d] cursor-not-allowed'
                        : 'text-sm font-semibold  bg-brandBlue text-white rounded-md'
                    }
                    onClick={() => setMintPop(true)}
                    disabled={
                      projectDetails?.total_minted - isNftTotalSupply === 0 ||
                      projectDetails.contract_address === null ||
                      isDetailsLoader === true
                        ? true
                        : false
                    }
                  >
                    Mint Now
                  </button>

                  {projectDetails &&
                    projectDetails?.total_minted - isNftTotalSupply === 0 &&
                    isFreeze && (
                      <button
                        onClick={() => unFreezeTransfer()}
                        className="mb-3 md:mb-0 mr-2 md:mr-0 bg-GreenColor text-brandBlue border border-GreenColor text-sm whitespace-nowrap"
                      >
                        Unfreeze
                      </button>
                    )}
                  {projectDetails &&
                    projectDetails?.total_minted - isNftTotalSupply === 0 &&
                    isFreeze === false && (
                      <button
                        onClick={() => freezeTransfer()}
                        className="mb-3 md:mb-0 mr-2 md:mr-0 bg-red-500 text-white border border-red-500 text-sm whitespace-nowrap"
                      >
                        Freeze
                      </button>
                    )}
                </div>
              </div>
            </div>

            <OnchainActivities
              load={isMintingListUpdate}
              projectId={projectId}
              projectDetailsFunction={getProjectDetails}
              setDeployButtonStatus={setDeployButtonStatus}
              setMintingListUpdate={setMintingListUpdate}
            />
          </div>
        </div>

        <InvestorsListing
          isLoader={isLoader}
          investorsList={investorsList}
          userRedirect={userRedirect}
        />
      </div>

      <Transition.Root show={isMintPop} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={() => {}}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-5 pb-10 pt-5 relative">
                    <button
                      onClick={() => {
                        setMintPop(false);
                        setNftMintQty(0);
                        setNftMintErrorMsg(null);
                      }}
                      className="w-10 h-10 flex items-center justify-center border border-gray-100 text-gray-600 rounded-full p-0 absolute top-3 right-3 hover:bg-gray-100"
                    >
                      <CrossIcon />
                    </button>
                    <div className="text-center sm:text-left">
                      <Dialog.Title
                        as="h3"
                        className="text-xl font-semibold leading-6 text-gray-900 mb-2"
                      >
                        Mint Tokens
                      </Dialog.Title>
                      <p className="text-gray-500">
                        By minting your tokens you are making it available for
                        sale!{' '}
                      </p>

                      <div className="mt-4">
                        <div className="relative">
                          <input
                            type="number"
                            onInput={(e) => checkError(e)}
                            onWheel={(e) => e.target.blur()}
                            value={isNftMintQty}
                            pattern="[0-9]"
                            className="px-5 py-4 rounded-lg border border-bordercolor"
                            placeholder="Enter Quantity"
                          />
                          <button
                            onClick={() => {
                              getMaxMintable();
                            }}
                            className="px-3 py-1 bg-[#E79853] text-sm text-brandBlue rounded absolute top-1/2 right-2 -translate-y-1/2"
                          >
                            Max
                          </button>
                        </div>
                        {isNftMintErrorMsg && (
                          <div className="text-red-500 text-sm text-left">
                            {isNftMintErrorMsg || 'NA'}
                          </div>
                        )}
                        {projectDetails.investment_type === 'asset' && (
                          <div className="bg-[#fff9e4] text-[#897530] text-xs text-left mt-2 p-3 rounded-md">
                            <span className="font-semibold">Note:</span> For a
                            safer minting experience, it&apos;s recommended to
                            mint a maximum of 5000 tokens. Exceeding this
                            quantity may increase the likelihood of encountering
                            issues during the minting process.
                          </div>
                        )}
                        <div className="flex items-center justify-between mt-4 mb-12">
                          <p className="text-brandBlue text-xl font-semibold">
                            Total: {projectDetails?.total_minted || 0}
                          </p>
                          <p className="text-brandBlue text-xl">
                            Tokens to be minted:
                            <span className="font-semibold">
                              {' '}
                              {projectDetails?.total_minted -
                                isNftTotalSupply || 0}{' '}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="w-full mt-5 text-center">
                      <button
                        onClick={() => nftMintRequest()}
                        className={
                          isNftMintErrorMsg
                            ? 'px-4 py-2.5 rounded-md font-medium text-white text-base bg-[#787a7d] cursor-not-allowed'
                            : 'px-4 py-2.5 rounded-md font-medium text-base text-brandBlue bg-GreenColor'
                        }
                        disabled={isNftMintErrorMsg ? true : false}
                      >
                        Mint now
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Transition.Root show={isMintingProcessPop} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={() => {}}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white p-6 pb-10 relative">
                    <div className="loading"></div>

                    <div className="text-center sm:text-left">
                      <img
                        src="/img/loading-circle.gif"
                        className="mx-auto mb-5"
                        alt=""
                      />

                      <div className="text-center">
                        <h4 className="mb-2">
                          {isBlockChainProcessMsg || 'NA'}
                        </h4>
                        <p className=" text-lg">
                          Please confirm the Metamask transaction
                        </p>
                        <p className="my-3">
                          <span className="w-14 h-[1px] bg-gray-400 mx-auto inline-block"></span>
                        </p>
                        <p className="text-gray-700">
                          Please do not close the window until transaction
                          get&apos;s completed.
                        </p>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Transition.Root show={isMintingConfirmationPop} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={() => {}}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-5 pb-10 pt-5 relative">
                    <button
                      onClick={() => setMintingConfirmationPop(false)}
                      className="w-10 h-10 flex items-center justify-center border border-gray-100 text-gray-600 rounded-full p-0 absolute top-3 right-3 hover:bg-gray-100"
                    >
                      <CrossIcon />
                    </button>
                    <div className="text-center sm:text-left">
                      <div className="mt-4 text-center">
                        <div className="w-full text-center">
                          <InfoCheckIcon />
                        </div>

                        <h4 className="mb-2 font-semibold">
                          To publish your project
                        </h4>
                        <p className=" text-lg mb-6">
                          You need to mint your total tokens first
                        </p>

                        {/* <p className="text-gray-700">Do doing this can avoid the future conflict.</p> */}
                      </div>
                    </div>
                    <div className="w-full mt-5 text-center">
                      <button
                        onClick={() => setMintingConfirmationPop(false)}
                        className="px-4 py-2.5 rounded-md font-medium text-base text-brandBlue bg-white border border-gray-300 mr-3"
                      >
                        I&apos;ll do it later
                      </button>
                      <button
                        onClick={() => {
                          setMintPop(true);
                          setMintingConfirmationPop(false);
                        }}
                        className="px-4 py-2.5 rounded-md font-medium text-base text-brandBlue bg-GreenColor"
                      >
                        Mint Tokens
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <Transition.Root show={isMintedSucessPop} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={() => {}}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-5 pb-10 pt-5 relative">
                    <button
                      onClick={() => {
                        setMintedSucessPop(false);
                      }}
                      className="w-10 h-10 flex items-center justify-center border border-gray-100 text-gray-600 rounded-full p-0 absolute top-3 right-3 hover:bg-gray-100"
                    >
                      <CrossIcon />
                    </button>
                    <div className="text-center sm:text-left">
                      <div className="mt-4 text-center">
                        <div className="w-full text-center">
                          <RightClickIcon />
                        </div>

                        <h4 className="mb-2 font-semibold">
                          Token minting has been initiated successfully,
                        </h4>
                        <p className=" text-lg mb-6">
                          You can track the minting progress in Onchain
                          Activities section
                        </p>
                      </div>
                    </div>
                    <div className="w-full mt-5 text-center">
                      <button
                        onClick={() => {
                          setMintedSucessPop(false);
                        }}
                        className="px-4 py-2.5 rounded-md font-medium text-base text-brandBlue bg-GreenColor"
                      >
                        Okay
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <Transition.Root show={isDeploySuccessPop} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={() => {}}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-5 pb-10 pt-5 relative">
                    <button
                      onClick={() => setDeploySuccessPop(false)}
                      className="w-10 h-10 flex items-center justify-center border border-gray-100 text-gray-600 rounded-full p-0 absolute top-3 right-3 hover:bg-gray-100"
                    >
                      <CrossIcon />
                    </button>
                    <div className="text-center sm:text-left">
                      <div className="mt-4 text-center">
                        <div className="w-full text-center">
                          <InfoCheckIcon />
                        </div>

                        <h4 className="mb-2 font-semibold">
                          Project deployment has been initiated successfully,
                        </h4>
                        <p className=" text-lg mb-6">
                          Please check the Onchain Activities Section to track
                          the project deployment status.
                        </p>
                      </div>
                    </div>
                    <div className="w-full mt-5 text-center">
                      <button
                        onClick={() => {
                          setDeploySuccessPop(false);
                        }}
                        className="px-4 py-2.5 rounded-md font-medium text-base text-brandBlue bg-GreenColor"
                      >
                        Okay!
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <ConfirmationPop
        isPop={isCommonConfirmationPop}
        setPop={setCommonConfirmationPop}
        functionCall={confirmationPopHandel}
        FirstText={isConfirmationPopData.FirstText}
        secondText={isConfirmationPopData.SecondText}
        FirstButton={isConfirmationPopData.FirstButton}
        secondButton={isConfirmationPopData.secondButton}
        slug={isConfirmationPopData.slug}
      />
    </div>
  );
};
export default ProjectDetails;

const ProjectInfo = ({
  isDetailsLoader,
  projectDetails,
  showDeployLoader,
  isDeployButtonStatus,
  editProjectRedirect,
  deployProject,
  setIsNavigateToEdit,
  publishProject,
}) => {
  let params = useParams();
  let projectId = params ? params.id : null;
  return (
    <>
      <div>
        {isDetailsLoader === false && (
          <div className=" rounded-2xl  mb-7">
            <Carousel>
              {projectDetails?.projectImages &&
                projectDetails?.projectImages.length > 0 &&
                projectDetails?.projectImages.map((image, index) => {
                  return (
                    <div key={index} className="h-[420px] relative">
                      <img
                        src={
                          image?.resourceUrl
                            ? image?.resourceUrl
                            : '/img/big_project_image.png'
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/img/big_project_image.png';
                        }}
                        className="object-cover w-full h-full rounded-lg"
                        alt=""
                      />
                      {projectDetails?.available_for_sale -
                        Number(projectDetails?.sold_quantity) ===
                        0 && (
                        <img
                          src="/img/sold-out.svg"
                          className="absolute top-0 left-0 max-w-[120px] h-auto"
                          alt=""
                        />
                      )}
                    </div>
                  );
                })}
            </Carousel>
          </div>
        )}

        {isDetailsLoader && (
          <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
            {/* Full-width skeleton */}
            <Skeleton height={400} />
            {/* Grid of 4 items */}
            <div className="p-4 grid grid-cols-4 gap-8 w-full bg-gray-50 rounded-xl mt-4">
              {Array.from({ length: 4 }).map((_, index) => (
                <Skeleton key={index} height={60} />
              ))}
            </div>
          </SkeletonTheme>
        )}

        {isDetailsLoader === false && (
          <>
            <div>
              <h3 className="border-b border-bordercolor pb-3 mb-3">
                {projectDetails?.name || '--'}
              </h3>
              <div className="mb-12 md:mb-6 xl:mb-0">
                <MDEditor.Markdown
                  source={projectDetails?.description || 'NA'}
                />
              </div>
            </div>
            {projectDetails?.description_dutch && (
              <div className="pt-6">
                <h3 className="font-semibold p-2">Dutch Description</h3>
                <h3 className="border-b border-bordercolor pb-3 mb-3">
                  {projectDetails?.name || '--'}
                </h3>

                <div className="mb-12 md:mb-6 xl:mb-0">
                  <MDEditor.Markdown
                    source={projectDetails?.description_dutch || 'NA'}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <div>
        {isDetailsLoader && (
          <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
            {/* Header Skeleton */}
            <Skeleton height={60} />
            {/* Grid Skeleton */}
            <div className="grid grid-cols-2 gap-x-8 gap-y-5 w-full mt-4">
              {Array.from({ length: 12 }).map((_, index) => (
                <Skeleton key={index} height={30} />
              ))}
            </div>
          </SkeletonTheme>
        )}

        {isDetailsLoader === false && (
          <div>
            <div className="md:flex items-center justify-between gap-4">
              <div className="flex items-center justify-between w-full">
                <button
                  onClick={() => editProjectRedirect(projectId)}
                  className="bg-brandBlue font-semibold text-white border  border-brandBlue inline-flex items-center text-sm mb-3 md:mb-0"
                >
                  <EditIcon />
                  Edit Project
                </button>
              </div>

              {projectDetails?.contract_address === null && (
                <button
                  onClick={() => deployProject()}
                  className={`mb-3 md:mb-0 mr-2 md:mr-0 font-semibold text-sm whitespace-nowrap ${
                    showDeployLoader || isDeployButtonStatus
                      ? 'text-white bg-[#787a7d] cursor-not-allowed'
                      : 'bg-GreenColor text-brandBlue border border-GreenColor'
                  }`}
                  disabled={showDeployLoader || isDeployButtonStatus}
                >
                  {showDeployLoader ? (
                    <div className="flex items-center gap-2">
                      <ProcessingIcon />
                      Deploying
                    </div>
                  ) : (
                    <div className="flex items-center gap-2 text-sm font-medium">
                      Deploy
                    </div>
                  )}
                </button>
              )}
              {projectDetails?.contract_address !== null && (
                <button
                  onClick={() => {
                    setIsNavigateToEdit(false);
                    publishProject(
                      projectDetails?.project_status,
                      projectDetails.total_minted,
                    );
                  }}
                  className="mb-3 md:mb-0 mr-2 md:mr-0 bg-GreenColor text-brandBlue border border-GreenColor text-sm font-medium whitespace-nowrap"
                >
                  {projectDetails?.project_status === 0
                    ? 'Publish '
                    : 'Unpublish '}
                </button>
              )}
            </div>
            <div className="border-b border-bordercolor pb-3 mb-3 mt-4">
              <h3 className="text-3xl font-semibold leading-normal">
                {projectDetails?.name || '--'}
              </h3>
              <p className="flex items-center gap-2">
                <img src="/img/mappin-icn.svg" alt="" />
                {projectDetails?.location || '--'}
              </p>
            </div>
            <div className="grid grid-cols-2 gap-3.5">
              <div>
                <label className="text-sm">Investment Type </label>
                <div>
                  {projectDetails?.investment_type === 'bond' && (
                    <p className="font-semibold">Bond</p>
                  )}
                  {projectDetails?.investment_type === 'asset' && (
                    <p className="font-semibold">Equity</p>
                  )}
                </div>
              </div>
              {projectDetails.issuer_name &&
                projectDetails?.investment_type === 'bond' && (
                  <div>
                    <label className="text-sm">Issuer Name </label>
                    <p className="font-semibold">
                      {projectDetails.issuer_name || 'NA'}
                    </p>
                  </div>
                )}
              <div>
                <label className="text-sm">Symbol </label>
                <p className="font-semibold">
                  {' '}
                  {projectDetails?.symbol || '0'}
                </p>
              </div>
              <div>
                <label className="text-sm">Project Type </label>
                <div className="flex items-center">
                  <img
                    src={projectDetails?.projectsType?.icon_url}
                    className="mr-1"
                    alt=""
                  />
                  {/* )} */}

                  <p className="font-semibold">
                    {projectDetails?.projectsType?.name || 'NA'}
                  </p>
                </div>
              </div>
              <div>
                <label className="text-sm">Total Supply</label>
                <p className="font-semibold">
                  {' '}
                  {projectDetails?.total_minted || '0'}
                </p>
              </div>
              <div>
                <label className="text-sm">Actual Tokens Minted </label>
                <p className="font-semibold">
                  {' '}
                  {projectDetails?.actual_total_supply || '0'}
                </p>
              </div>
              <div>
                <label className="text-sm">Project cost</label>
                <p className="font-semibold">
                  {' '}
                  {projectDetails?.project_cost
                    ? formatValue(projectDetails?.project_cost, {
                        decimalPlaces: 2,
                      })
                    : 'NA'}
                </p>
              </div>{' '}
              <div>
                <label className="text-sm"> Price</label>
                <p className="font-semibold">
                  {projectDetails?.price
                    ? formatValue(projectDetails.price, { decimalPlaces: 2 })
                    : '0.00'}
                </p>
              </div>
              <div>
                <label className="text-sm"> Available For Sale</label>
                <p className="font-semibold">
                  {projectDetails?.available_for_sale || '0'}
                </p>
              </div>
              <div>
                <label className="text-sm"> Available Supply</label>
                <p className="font-semibold">
                  {projectDetails?.available_for_sale -
                    Number(projectDetails?.sold_quantity) || '0'}
                  <span className="text-[#85919F] font-semibold">
                    {' '}
                    {projectDetails?.lock_qty_total > 0
                      ? `(${Number(projectDetails?.lock_qty_total)} locked)`
                      : ''}
                  </span>
                </p>
              </div>
              <div>
                <label className="text-sm">Energy Capacity</label>
                <p className="font-semibold">
                  {projectDetails?.energy_capacity + ' MW' || 'NA'}{' '}
                </p>
              </div>
              <div>
                <label className="text-sm">Nominal Value</label>
                <p className="font-semibold">
                  {projectDetails?.nominal_value
                    ? formatValue(projectDetails.nominal_value, {
                        decimalPlaces: 2,
                      })
                    : '0.00'}
                </p>
              </div>
              {projectDetails.investment_type === 'bond' && (
                <div>
                  <label className="text-sm">ISIN</label>
                  <p className="font-semibold">
                    {projectDetails?.isin ? projectDetails?.isin : 'NA'}
                  </p>
                </div>
              )}
              <div>
                <label className="text-sm">Expected APY</label>
                <p className="font-semibold">
                  {projectDetails?.expected_apy
                    ? projectDetails?.expected_apy + ' %'
                    : 'NA'}
                </p>
              </div>
              {projectDetails.investment_type === 'bond' && (
                <div>
                  <label className="text-sm">Bond Issue Date</label>
                  <p className="font-semibold">
                    {projectDetails?.bond_issue_date
                      ? ConfigService.formatDate(
                          projectDetails?.bond_issue_date,
                        )
                      : 'NA'}
                  </p>
                </div>
              )}
              {projectDetails.investment_type === 'bond' && (
                <div>
                  <label className="text-sm">Maturity Date</label>
                  <p className="font-semibold">
                    {projectDetails?.maturity_date
                      ? ConfigService.formatDate(projectDetails?.maturity_date)
                      : 'NA'}
                  </p>
                </div>
              )}
              {projectDetails.investment_type === 'bond' && (
                <div>
                  <label className="text-sm">Min. Purchase Limit</label>
                  <p className="font-semibold">
                    {projectDetails?.min_purchase_qty
                      ? projectDetails?.min_purchase_qty
                      : 'NA'}
                  </p>
                </div>
              )}
              {projectDetails.investment_type === 'bond' && (
                <div>
                  <label className="text-sm">Interest Rate</label>
                  <p className="font-semibold">
                    {projectDetails?.interest_rate
                      ? projectDetails?.interest_rate + ' %'
                      : 'NA'}
                  </p>
                </div>
              )}
              {projectDetails.investment_type === 'bond' && (
                <div>
                  <label className="text-sm">Payout Cycle</label>
                  <p className="font-semibold">
                    {ConfigService.toTitleCase(projectDetails?.payout_cycle) ||
                      'NA'}
                  </p>
                </div>
              )}
              {projectDetails.investment_type === 'bond' && (
                <div>
                  <label className="text-sm">Schedule Type</label>
                  <p className="font-semibold">
                    {ConfigService.toTitleCase(
                      projectDetails?.schedule_type === 'every_period'
                        ? 'Every Period'
                        : 'End of Quarter',
                    ) || 'NA'}
                  </p>
                </div>
              )}
              <div>
                <label className="text-sm">Lifespan</label>
                <p className="font-semibold">
                  {ConfigService.formatDate(projectDetails?.life_span_from) ||
                    'NA'}
                  {' - '}
                  {ConfigService.formatDate(projectDetails?.life_span_to) ||
                    'NA'}
                </p>
              </div>
              <div>
                <label className="text-sm">Remaining lifetime</label>
                <p className="font-semibold">
                  {Math.max(
                    moment(projectDetails?.life_span_to).year() -
                      moment().year(),
                  )}{' '}
                  years left
                </p>
              </div>
              {(projectDetails?.inrisc_score ||
                projectDetails?.inrisc_score !== 0) && (
                <div>
                  <label className="text-sm">Inrisc score</label>
                  <p className="font-semibold">
                    {projectDetails?.inrisc_score || 'NA'}
                  </p>
                </div>
              )}
              <div>
                <label className="text-sm">eSignature template ID [EN]</label>
                <p className="font-semibold">
                  {projectDetails?.esignature_template_id_en
                    ? projectDetails?.esignature_template_id_en
                    : 'NA'}{' '}
                </p>
              </div>
              <div>
                <label className="text-sm">eSignature template ID [NL]</label>
                <p className="font-semibold">
                  {projectDetails?.esignature_template_id_nl
                    ? projectDetails?.esignature_template_id_nl
                    : 'NA'}{' '}
                </p>
              </div>
              <div className="col-span-2">
                <label className="text-sm">Professional Investors : </label>
                <p className="font-semibold">
                  {projectDetails?.professional_investors_only === 1
                    ? 'Active'
                    : projectDetails?.professional_investors_only === 0
                      ? 'Inactive'
                      : 'NA'}
                </p>
              </div>
              <div className="col-span-2">
                <label className="text-sm">InRisc Score Link </label>
                <div className="font-semibold truncate">
                  {projectDetails?.inrisc_score_link ? (
                    <a
                      rel="noreferrer"
                      href={projectDetails?.inrisc_score_link}
                      target="_blank"
                      className="font-medium text-sm  text-blue-500 flex items-center"
                    >
                      <GoToLinkIcon />
                      <span className="truncate w-3/4">
                        {projectDetails?.inrisc_score_link || 'NA'}
                      </span>
                    </a>
                  ) : (
                    'NA'
                  )}
                </div>
              </div>
              {projectDetails.investment_type === 'bond' && (
                <div className="col-span-2">
                  <label className="text-sm">Agreement Term</label>
                  <div className="font-semibold truncate">
                    {projectDetails?.agreement_term_url ? (
                      <a
                        rel="noreferrer"
                        href={projectDetails?.agreement_term_url}
                        target="_blank"
                        className="font-medium text-sm  text-blue-500 flex items-center"
                      >
                        <GoToLinkIcon />
                        <span className="truncate w-3/4">
                          {projectDetails?.agreement_term_url || 'NA'}
                        </span>
                      </a>
                    ) : (
                      'NA'
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="grid grid-cols-1 gap-4">
              <div className="col-span-2 border-b border-bordercolor pb-3"></div>
              <div className="col-span-2">
                <p className="font-semibold mb-4">Project Related Documents</p>
                <div className="bg-white">
                  <div className="overflow-auto h-auto">
                    {projectDetails?.projectDocument &&
                    projectDetails?.projectDocument.length > 0 ? (
                      projectDetails?.projectDocument.map((document) => {
                        return (
                          <div
                            key={document.id}
                            className="relative pr-40 border border-gray-100 pb-2 rounded-md mb-2  p-2"
                          >
                            <div className="flex items-center gap-4 relative top-0">
                              <div>
                                <img
                                  src="/img/PDF-Icon.png"
                                  className="max-w-[18px]"
                                  alt=""
                                />
                              </div>
                              <p className="truncate">
                                {document?.name
                                  ? document?.name?.substr(0, 80)
                                  : 'NA'}
                              </p>
                            </div>
                            <a
                              href={document.resourceUrl}
                              target="_blank"
                              rel="noreferrer"
                              className="absolute right-2 top-[6px] flex gap-2 items-center bg-GreenColor text-brandBlue px-2 py-1 rounded-sm text-sm"
                            >
                              <img
                                src="/img/downloadicon.svg"
                                alt="Download icon"
                              />{' '}
                              Download
                            </a>
                          </div>
                        );
                      })
                    ) : (
                      <div>
                        <p className=" bg-gray-50 rounded-md">
                          Project documents are not available.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const InvestorsListing = ({ isLoader, investorsList, userRedirect }) => {
  const tableConfig = {
    columns: {
      user_name: {
        title: 'User Name',
        render: (data) => {
          return data?.userData?.full_name || 'NA';
        },
      },
      user_email: {
        title: 'User Email',
        render: (data) => {
          return data?.userData?.email || 'NA';
        },
      },
      no_of_token: {
        title: 'No. of Token',
        render: (data) => {
          return data?.NFT_total_quantity || '0';
        },
      },
      dividend_due: {
        title: 'Payout Due',
        render: (data) => {
          return data?.user_payout_history?.[0]?.status === 0
            ? formatValue(data?.user_payout_history?.[0]?.payout_amount, {
                decimalPlaces: 2,
              })
            : '0';
        },
      },
      total_dividend_due: {
        title: 'Total Payouts Paid',
        render: (data) => {
          return (
            formatValue(data?.total_paid_payout_amount, {
              decimalPlaces: 2,
            }) || '0'
          );
        },
      },
    },
    data: investorsList,
  };

  return (
    <div className="mb-4 bg-brandGray p-6 col-span-2 rounded-lg mt-5">
      <div className="pb-2 mb-2 border-b border-[#B6BDC5] flex justify-between w-full items-center">
        <h3 className="">Investors</h3>
        <div className="lg:flex lg:items-center lg:justify-end gap-2 mt-5 mb-2"></div>
      </div>

      <div className="flex flex-col relative overflow-x-auto">
        <TableComponent
          tableConfig={tableConfig}
          isListLoader={isLoader}
          isList={investorsList}
          redirectTo={userRedirect}
        />
        {investorsList && investorsList?.length === 0 && isLoader === false && (
          <>
            <NoDataFound />
          </>
        )}
      </div>
    </div>
  );
};
